import react from 'react';
import timezones from "./timezones.json";
import CountrySelect from './CountrySelect';
import { tzMap } from './utils/getTimeZone';

const TimeZonePicker = (props) => {

    let guideData = JSON.parse(localStorage.getItem('guideData')) || {};

    let timeZones = JSON.parse(JSON.stringify(timezones));

    let theTimeZonesForCountry = [];

    if(guideData.country) {
        theTimeZonesForCountry = timeZones.filter(tz => tz.country === guideData.country.name);
    }

    theTimeZonesForCountry = theTimeZonesForCountry[0] ? theTimeZonesForCountry[0].zones : [];
    const [country, setCountry] = react.useState(props.selectedCountry || guideData.country);
    const [timeZonesForCountry, setTimeZonesForCountry] = react.useState(theTimeZonesForCountry);
    const [timeZone, setTimeZone] = react.useState(props.timeZone);

    const handleCountryChange = (selectedCountry) => {
        setTimeZone(null);
        setCountry(selectedCountry);
        props.setCountry?.(selectedCountry);
        let theTimeZonesForCountry = timeZones.filter(tz => tz.country === selectedCountry.name);
        theTimeZonesForCountry = theTimeZonesForCountry[0] ? theTimeZonesForCountry[0].zones : [];
        if (theTimeZonesForCountry && theTimeZonesForCountry.length > 1) {
            setTimeZonesForCountry(theTimeZonesForCountry);
        } else if (theTimeZonesForCountry && theTimeZonesForCountry.length === 1) {
            setTimeZonesForCountry(theTimeZonesForCountry[0]);
            setTimeZone(theTimeZonesForCountry[0].utc_offset);
            props.onChange?.(theTimeZonesForCountry[0].utc_offset);
            props.setTimeZone?.(theTimeZonesForCountry[0].utc_offset);
        }
    };

    const handleTimeZoneChange = (event) => {
        setTimeZone(event.target.value);
        props.onChange?.(event.target.value);
        props.setTimeZone?.(event.target.value);
    };

    return (
        <div className="timezone-picker">
            {!country && <CountrySelect onChange={handleCountryChange} didMakeSelection={timeZone !== null} />}
            {country && <span onClick={() => setCountry(null)}>{country.name} {country.flag}{" "}</span>}
            {country && !timeZone && timeZonesForCountry?.length > 1 && (
                <select className="select-specific-timezone" onChange={handleTimeZoneChange} value={timeZone}>
                    <option value="" disabled>Select Time Zone</option>
                    {timeZonesForCountry?.map((tz, index) => (
                        <option key={"timezone-" + index} value={tzMap[tz.utc_offset]}>{tzMap[tz.utc_offset]}</option>
                    ))}
                </select>
            )}
            {country && timeZone && (
                <span onClick={() => setTimeZone(null)}>{timeZone}</span>
            )}
        </div>
    );
};

export default TimeZonePicker;